import { useMemo } from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'
import { useOverlay } from '../overlay'
import { focusLastMenuItem } from './utils'

/**
 * This hook is used in UncontrolledMenuOverlay and should be used by
 * any consumers of ControlledMenuOverlay to improve accessibility.
 */
export default function useMenuOverlay(...args) {
  // ID that will get set on the underlying <ul>
  const menuId = useRandomId()
  const overlay = useOverlay(...args)

  const { isOpen, handleClick } = overlay

  const menuButtonProps = useMemo(
    () => ({
      onClick: handleClick,
      onKeyDown: (event) => {
        const { key, metaKey, ctrlKey } = event
        if (!isOpen && ['ArrowDown', 'ArrowUp'].includes(key) && !metaKey && !ctrlKey) {
          handleClick(event)
          event.preventDefault()
          if (key === 'ArrowUp') {
            focusLastMenuItem(event, menuId)
          }
        }
      },
      'aria-haspopup': true,
      'aria-expanded': isOpen,
      'aria-controls': menuId,
      'aria-owns': menuId,
    }),
    [handleClick, isOpen, menuId]
  )

  return { ...overlay, menuId, menuButtonProps }
}
